export const commonEnvironment = {
  maxFileSize: 1024 * 1024 * 1024,
  version: '0.0.0',
  imageLabelId: '06d43f54-33a7-4374-9234-14bb02f00946',
  useIdp: true,
  showAllIdp: false,
  emailLabelId: '40e8dd6f-9d67-4cdb-bc78-cb5f518f382f',
  sentry: null as string,
  citrixAuthUrl: 'https://dp-login.walo.ch',
  updatePollingInterval: 60,
  updatePollingIntervalDelay: 10,
};
